import { ActivityIndicator, ActivityIndicatorProps } from "react-native";

// --color-neutral-950
const NEUTRAL_950 = "rgb(23, 23, 23)";

const Spinner = ({ color = NEUTRAL_950, ...props }: ActivityIndicatorProps) => (
	<ActivityIndicator color={color} {...props} />
);

Spinner.displayName = "Spinner";

export { Spinner };
